
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23V19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5V1Z" fill="currentColor"></path></svg>';export default svg;
    